<template lang="pug">
.padding
    h5._300.margin Region
    
    .box
        v-server-table(
            ref="datatable" 
            :url="api" 
            :name="tableName" 
            :columns="columns" 
            :options="options"
        )

            template(slot="outlets" slot-scope="props")
                collection-counter(
                    label="name"
                    :subject="`${trans('general.outlets_assigned')}`"
                    :collection="props.row.outlets"
                )

    region-form(ref="regionForm")

</template>

<script>
import Auth from '@js/plugins/auth';
import regionForm from './region-form.vue';
import eventRegion from './region-event';
import CollectionCounter from '@js/components/collection-counter';

export default {
    components: {
        regionForm,
        CollectionCounter,
    },
    data() {
        let canManageRegion = Auth.hasPermissionTo('franchise_manage_regions');

        let actionButtons = [
            {
                title: 'Create Region',
                action: () => {
                    this.showRegion(null);
                },
            },
        ];

        if (!canManageRegion) {
            actionButtons = [];
        }

        return {
            tableName: 'VUETABLE_REGION',
            columns: ['name', 'outlets'],
            options: {
                checkbox: canManageRegion,
                sortable: ['name'],

                rowClickCallback: row => {
                    this.showRegion(row.id);
                },

                rowClassCallback: () => 'pointer',

                actionButtons: actionButtons,

                checkbox_actions: {
                    api_delete: Laroute.route('franchise.region.delete'),
                    delete_title: 'Delete Region',
                },

                headings: {
                    outlets: this.trans('general.outlets'),
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.region.index');
        },
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        showRegion(id) {
            this.$refs.regionForm.$emit('show-region', id);
        },

        registerEvent() {
            this.$refs.regionForm.$on('region-saved', () => {
                this.$refs.datatable.getData();
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/region/region-list.vue